import { makeStyles } from "tss-react/mui";

export const homeStyles = makeStyles()(() => ({
  description: {
    margin: "20px 0px",
    lineHeight: "24px",
    fontFamily: "MD Primer",
    fontWeight: "400",
    fontSize: "16px",
    "@media(min-width: 1570px)": {
      margin: "20px 0px",       
    },
  },
  features: {
    width: "43%",    
  },
  feature: {
    display: "flex",
    alignItems: "top",
    fontSize: 15,
    gap: "16px",
    margin: "0 0 2px 0",
    "& img ": {
      margin: "15px 20px 0 0",
    },
  },
  featureContent:{
    gap:"8px"
  },
  featureTitle: {
    marginTop: 9,
    letterSpacing: 3,
    lineHeight: "24px",
    fontFamily: "MD Primer",
    fontWeight: "600",
    fontSize: "16px",
    "@media(min-width: 1570px)": {
      marginTop: 6,     
    },
  },
  featureText: {    
    marginTop: 3,
    lineHeight: "22px",
    fontFamily: "MD Primer",
    fontWeight: "400",
    fontSize: "16px",
    "@media(min-width: 1570px)": {
      margin: "3px 0px 24px",   
    },
  },
  homeContainer: {
    position: "relative",
    width: "100%",
    height: "calc(100vh - 64px)",
    top: 0,
    left: 0,
    overflow: "hidden",
    display:"flex",
    justifyContent: "center",
    alignItems: "center"
  },
  home: {
    position:"absolute",    
    left: 0,
    top: 0, 
    width: "100%",
    height: "100vh",    
    zIndex: -1,
    "& img": {
      width: "100%", 
      objectFit:"cover"     
    }
  },
  featureIcon: {
    marginTop: "8px"
  },
  title: {
    margin: 0,
    lineHeight: "100%",
    fontFamily: "MD Primer",
    fontWeight: "600",
    fontSize: "40px",
    marginTop: 30,
    "@media(min-width: 1570px)": {
      marginTop: 40,      
    },
  },
  topRow: {
    width: "43%",
    gap:"8px"
  },
  homeIcon: {
    width: "40px !important",
    height: "40px !important",
    fontSize: "40px !important",
  },
}));
